@if (showSidenav()) {
  <app-sidenav>
    <router-outlet></router-outlet>
  </app-sidenav>
} @else {
  <router-outlet></router-outlet>
}
